module.exports = __webpack_public_path__ + "media/images/meta/bft/apple-touch-icon-9a733d37b8497d7a7d4ebe543fffdd64.png";